import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import axios from 'axios'
// import { store } from '@/store'

Vue.use(Vuex)
Vue.use(VueRouter)

/* eslint-disable */
const router = new VueRouter({
  routes: [
    {
      path: '/surveys/:id',
      name: 'Surveys',
      component: () => import("@/pages/Surveys.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/link/:id',
      name: 'SurveysLink',
      component: () => import("@/pages/Surveys.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },    
    // {
    //   path: '/image-editor',
    //   name: 'ImageEditor',
    //   component: () => import("@/components/ImageEditor.vue"),
    //   meta: { requiresAuth: false, layout: "no-sidebar" },
    // },
    {
      path: '/invoice/:id',
      name: 'Invoice',
      component: () => import("@/components/Invoice.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/automation',
      name: 'Automation',
      component: () => import("@/pages/Automation.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/automation/new',
      name: 'AutomationNew',
      component: () => import("@/components/AutomationNew.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/automation/:id',
      name: 'AutomationUpdate',
      component: () => import("@/components/AutomationNew.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },

    {
      path: '/card/add',
      name: 'CardNew',
      component: () => import("@/components/Card.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/nps/:id',
      name: 'Nps',
      component: () => import("@/pages/Nps.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    // {
    //   path: '/survey',
    //   name: 'Survey',
    //   component: () => import("@/pages/Survey.vue"),
    //   meta: { requiresAuth: false, layout: "no-sidebar" }
    // },
    {
      path: '/video/:key',
      name: 'Video',
      component: () => import("@/components/Video.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },
    {
      path: '/live-recording/:key',
      name: 'LiveRecording',
      component: () => import("@/components/Video.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },    
    {
      path: '/share/playback/:key',
      name: 'Share',
      component: () => import("@/components/Video.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/export/heatmap/:heatmap_profile_id/:device/:mode',
      name: 'ExportHeatmap',
      component: () => import("@/components/HeatmapContent3.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/export/heatmap/:encryptedParam',
      name: 'ExportHeatmapNew',
      component: () => import("@/components/HeatmapContinuous.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/share/heatmap/:heatmap_profile_id',
      name: 'ShareHeatmap',
      component: () => import("@/components/HeatmapContent3.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/export/recording/:key',
      name: 'ExportRecording',
      component: () => import("@/components/Video.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/',
      name: 'Dashboard',
      meta: { requiresAuth: true, layout: 'auth' },
      component: () => {
        // if (window.location.href.includes('howuku.com') || window.location.href.startsWith('http://localhost:80'))
        return import("@/pages/Dashboard.vue")

        // else
          // return import("@/pages/DashboardOld.vue")
      },
      beforeEnter: (to, from, next) => {
        let planArray = [0, 4, 101, 102, 103, 105, 201, 202, 203]
        // if (window.location.href.includes('howuku.com') || window.location.href.startsWith('http://localhost:80'))
        // window.location.host.includes('howuku.com') ==> whitelabel
        if (router.app.$isOptimize) {
          next('/get-started')
        } else if ( planArray.includes(router.app.$session.get('paid_plan')) && !router.app.$isWhitelabel()) {
          next({
            path:'/overview'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/thank-you/success',
      name: 'MidaThankYou',
      component: () => import("@/components/MidaThankYou.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },        
    {
      path: '/shop-upgrade/success',
      name: 'ShopifyThankYou',
      component: () => import("@/components/ShopifyThankYou.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },    
    {
      path: '/tool/hypothesis',
      name: 'HypothesisGenerator',
      component: () => import("@/components/FreeTools/ABHypothesis.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },      
    {
      path: '/tool/sample-size',
      name: 'SampleSizeCalculator',
      component: () => import("@/components/FreeTools/SampleSizeCalculator.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },    
    {
      path: '/tool/duration-calculator',
      name: 'DurationCalculator',
      component: () => import("@/components/FreeTools/DurationCalculator.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },        
    {
      path: '/tool/headline-suggestion',
      name: 'HeadlineSuggestion',
      component: () => import("@/components/FreeTools/HeadlineSuggestion.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },
    {
      path: '/tool/qrcode',
      name: 'Qrcode',
      component: () => import("@/components/FreeTools/Qrcode.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },     
    {
      path: '/qrcode',
      name: 'Qrcode',
      component: () => import("@/components/Qrcode.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },  
    {
      path: '/integration',
      name: 'Integration',
      component: () => import("@/components/Integration.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },    
    {
      path: '/tool/blog-idea-suggestion',
      name: 'BlogIdeaSuggestion',
      component: () => import("@/components/FreeTools/BlogIdeas.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },
    {
      path: '/tool/a-b-testing-significance-calculator',
      name: 'ABSignificantCalculator',
      component: () => import("@/components/FreeTools/ABSignificantCalculator.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },
    {
      path: '/shop',
      name: 'Shopify',
      component: () => import("@/pages/Login.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },
    {
      path: '/shop/register',
      name: 'ShopifyNew',
      component: () => import("@/pages/Register.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import("@/pages/Dashboard.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/events',
      name: 'Events',
      component: () => import("@/pages/Events.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/behavior-flow',
      name: 'BehaviorFlow',
      component: () => import("@/pages/BehaviorFlow.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/events/:key/:value',
      name: 'EventsDetail',
      component: () => import("@/components/EventDetail.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    }, 
    {
      path: '/aa-test',
      name: 'A/A Split Test',
      component: () => import("@/pages/AbTest.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/aa-test/new',
      name: 'Add new A/A Test',
      component: () => import("@/components/CreateTestProfile.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },
    {
      path: '/aa-test/edit/:test_id',
      name: 'Edit A/A Test',
      component: () => import("@/components/CreateTestProfile.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },
    {
      path: '/aa-test/setup/:test_id',
      name: 'A/A Setup',
      component: () => import("@/components/AbSetup.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },
    {
      path: '/autopilot',
      name: 'Autopilot',
      component: () => import("@/components/Workshop.vue"),
      beforeEnter: (to, from, next) => {
        // only available for Optimize
        if (router.app.$isOptimize) {
          next()
        } else {
          next({ path:'/overview' })
        }
      },      
      meta: { requiresAuth: true, layout: "auth" }
    },    
    {
      path: '/aa-test/goal/:test_id',
      name: 'A/A Setup Goal',
      component: () => import("@/components/TestGoal.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },
    {
      path: '/aa-test/:test_id/results',
      name: 'A/A Result',
      component: () => import("@/components/AbTestResult.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/experiment',
      name: 'Experiment',
      component: () => import("@/pages/AbTest.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/deploy',
      name: 'Deploy',
      component: () => import("@/pages/AbTest.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },    
    {
      path: '/experiment/new',
      name: 'New Experiment',
      component: () => import("@/components/CreateTestProfile.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/deploy/new',
      name: 'New Deploy',
      component: () => import("@/components/CreateTestProfile.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/deploy/edit/:test_id',
      name: 'Edit Deploy',
      component: () => import("@/components/CreateTestProfile.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },    
    {
      path: '/experiment/edit/:test_id',
      name: 'Edit Experiment',
      component: () => import("@/components/CreateTestProfile.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/conclusion/edit/:test_id',
      name: 'Edit Conclusion',
      component: () => import("@/components/Conclusion.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/experiment/setup/:test_id',
      name: 'Setup Experiment',
      component: () => import("@/components/AbSetup.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },
    {
      path: '/deploy/setup/:test_id',
      name: 'Setup Deploy',
      component: () => import("@/components/AbSetup.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },    
    {
      path: '/experiment/configuration/:test_id',
      name: 'Experiment Configuration',
      component: () => import("@/components/AbConfiguration.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },  
    {
      path: '/experiment/launch/:test_id',
      name: 'Experiment Launch',
      component: () => import("@/components/AbLaunch.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },        
    {
      path: '/deploy/setup/:test_id',
      name: 'Setup Deploy',
      component: () => import("@/components/AbSetup.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },
    {
      path: '/goals/new',
      name: 'AddGoal',
      component: () => import("@/components/GoalDetail.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/goals/edit/:goal_profile_id',
      name: 'EditGoal',
      component: () => import("@/components/GoalDetail.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/goals/view/:goal_profile_id',
      name: 'ViewGoal',
      component: () => import("@/components/GoalInfo.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/goals',
      name: 'Goals',
      component: () => import("@/pages/Goals.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/event-tracking/new',
      name: 'AddEventTracking',
      component: () => import("@/components/EventTracking.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/event-tracking/edit/:event_config_id',
      name: 'EditEventTracking',
      component: () => import("@/components/EventTracking.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/event-tracking/view/:event_config_id',
      name: 'ViewEventTracking',
      component: () => import("@/components/EventTracking.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    }, 
    {
      path: '/event-tracking',
      name: 'EventTracking',
      component: () => import("@/pages/EventConfig.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },   
    {
      path: '/experiment/goal/:test_id',
      name: 'Setup Goal',
      component: () => import("@/components/TestGoal.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/experiment/:test_id/results',
      name: 'Experiment Result',
      component: () => import("@/components/AbTestResult.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/experiment/:test_id/resultb',
      name: 'Experiment Result',
      component: () => import("@/components/AbTestResultV2.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },    
    {
      path: '/experiment/configuration/:test_id/',
      name: 'Configuration Setting',
      component: () => import("@/components/AbConfiguration.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/experiment/targeting/:test_id/:from?',
      name: 'Targeting Setup',
      component: () => import("@/components/AbTargeting.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/deploy/targeting/:test_id/:from?',
      name: 'Targeting Setup',
      component: () => import("@/components/AbTargeting.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },    
    {
      path: '/experiment/edit/targeting/:test_id/:from?',
      name: 'Targeting Setup',
      component: () => import("@/components/AbTargeting.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/feature-flag',
      name: 'Feature Flag',
      component: () => import("@/pages/FeatureFlag.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },      
    {
      path: '/feature-flag/new',
      name: 'Feature Flag New',
      component: () => import("@/components/FeatureFlagDetail.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },  
    {
      path: '/feature-flag/edit/:id',
      name: 'Feature Flag Edit',
      component: () => import("@/components/FeatureFlagDetail.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },      
    {
      path: '/ab-test',
      name: 'A/B Split Test',
      component: () => import("@/pages/AbTest.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/ab-test/new',
      name: 'Add new A/B Test',
      component: () => import("@/components/CreateTestProfile.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/ab-test/edit/:test_id',
      name: 'Edit A/B Test',
      component: () => import("@/components/CreateTestProfile.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/ab-test/setup/:test_id',
      name: 'A/B Setup',
      component: () => import("@/components/AbSetup.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },
    {
      path: '/ab-test/goal/:test_id',
      name: 'A/B Setup Goal',
      component: () => import("@/components/TestGoal.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/ab-test/:test_id/results',
      name: 'A/B Result',
      component: () => import("@/components/AbTestResult.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/personalize',
      name: 'Personalized Experience',
      component: () => import("@/pages/AbTest.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/personalize/new',
      name: 'New Personalized Experience',
      component: () => import("@/components/CreateTestProfile.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/personalize/setup/:test_id',
      name: 'Personalized Experience Setup',
      component: () => import("@/components/AbSetup.vue"),
      meta: { requiresAuth: true, layout: "no-sidebar" }
    },
    {
      path: '/personalize/goal/:test_id',
      name: 'Personalized Experience Setup Goal',
      component: () => import("@/components/TestGoal.vue"),
      meta: { requiresAuth: true, layout: "auth" }
    },
    {
      path: '/personalize/:test_id/results',
      name: 'Personalized Experience Result',
      component: () => import("@/components/AbTestResult.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/funnel',
      name: 'Funnel',
      component: () => import("@/pages/Funnel.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/funnel/flow/:id/:id_name',
      name: 'Funnel Flow',
      component: () => import("@/components/FunnelDetail.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    // {
    //   path: '/form',
    //   name: 'Form',
    //   component: () => import("@/pages/FormAnalytics.vue"),
    //   meta: { requiresAuth: true, layout: 'auth' }
    // },
    {
      path: '/form',
      name: 'Form',
      component: () => import("@/pages/FormProfile.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/form/list',
      name: 'Form',
      component: () => import("@/pages/FormProfile.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/form/new',
      name: 'New Form',
      component: () => import("@/components/FormAnalyticsNew.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/form/result',
      name: 'Form Result',
      component: () => import("@/components/FormResult.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/form/result/:id',
      name: 'Form Result',
      component: () => import("@/components/FormResult.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/form/:id',
      name: 'Form Update',
      component: () => import("@/components/FormAnalyticsNew.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/payment/success',
      name: 'Success',
      component: () => import("@/components/PaymentSuccess.vue"),
      meta: { layout: "no-sidebar", requiresAuth: true },
    },
    {
      path: '/',
      name: 'Login',
      meta: { layout: "no-sidebar", requiresAuth: false },
      component: require("@/pages/Login.vue").default
    },
    {
      path: '/login',
      name: 'Login',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/Login.vue")
    },
    {
      path: '/hwlogin',
      name: 'Login2',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/Login.vue")
    },
    {
      path: '/sign-up-2',
      name: 'RegisterNew',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/RegisterNew.vue")
    },    
    {
      path: '/sign-up-1',
      name: 'RegisterNew2',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/RegisterNew2.vue")
    },        
    {
      path: '/sign-up',
      name: 'Register',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/Register.vue")
    },
    {
      path: '/appsumo/activation',
      name: 'RegisterAppsumo',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/Register.vue")
    },    
    {
      path: '/sign-up/tech-in-asia',
      name: 'RegisterEvent',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/RegisterEvent.vue")
    },
    {
      path: '/sign-up/:plan',
      name: 'Register',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/Register.vue")
    },
    // {
    //   path: '/sign-up/recommendation',
    //   name: 'Register',
    //   meta: { requiresAuth: false, layout: "no-sidebar" },
    //   component: () => import("@/pages/Register.vue")
    // },
    {
      path: '/join-howuku/:refname',
      name: 'RegisterRef',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/Register.vue")
    },
    {
      path: '/lifetimedeal',
      name: 'Register',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/Register.vue")
    },
    {
      path: '/google-signup',
      name: 'GoogleSignup',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/LoginRedirection.vue")
    },
    {
      path: '/affiliate-program',
      name: 'Affiliate',
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' },
      component: () => import("@/pages/Affiliate.vue")
    },
    {
      path: '/sign-up/:email',
      name: 'Register2',
      meta: { requiresAuth: false, layout: "no-sidebar" },
      component: () => import("@/pages/Register2.vue")
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      meta: { layout: "no-sidebar", requiresAuth: false },
      component: () => import("@/pages/ForgotPassword.vue")
    },
    {
      path: '/reset-password/:encodedId',
      name: 'ResetPassword',
      meta: { layout: "no-sidebar", requiresAuth: false },
      component: () => import("@/pages/ResetPassword.vue")
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/:key1/:value1',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/:key1/:value1/:key2/:value2',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/:key1/:value1/:key2/:value2/:key3/:value3',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:key4/:value4',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:key4/:value4/:key5/:value5',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:key4/:value4/:key5/:value5/:key6/:value6',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:key4/:value4/:key5/:value5/:key6/:value6/:key7/:value7',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:key4/:value4/:key5/:value5/:key6/:value6/:key7/:value7/:key8/:value8',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/country/:country',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/referrer/:refs',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/analytics/*',
      name: 'Analytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/report',
      name: 'Report',
      component: () => import("@/components/Report.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },         
    {
      path: '/refer-and-earn',
      name: 'ReferAndEarn',
      component: () => import("@/pages/ReferEarn.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' },
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import("@/pages/Logout.vue"),
      meta: { requiresAuth: false }
    },
    {
      path: '/users',
      name: 'Users',
      component: () => import("@/pages/Contact.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/visitors',
      name: 'Visitors',
      component: () => import("@/pages/Contact.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/visitor/realtime',
      name: 'Visitor',
      component: () => import("@/pages/VisitorRealtime.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/visitor/map',
      name: 'VisitorMaps',
      component: () => import("@/pages/VisitorMap.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/visitor/retention',
      name: 'VisitorRetention',
      component: () => import("@/pages/VisitorRetention.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/visitor/monthly-chart',
      name: 'MonthlyChart',
      component: () => import("@/pages/VisitorMonthlyChart.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/visitor/acquisition',
      name: 'AcqChannel',
      component: () => import("@/pages/VisitorAcquisition.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/feedback',
      name: 'Feedback',
      component: () => import("@/pages/Feedback.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/feedback/:feedbackId',
      name: 'ViewFeedback',
      component: () => import("@/components/FeedbackDetail.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/feedback/detail/:commentId',
      name: 'FeedbackInfo',
      component: () => import("@/components/FeedbackInfo.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/feedback/public/:companyId/:commentId',
      name: 'PublicFeedback',
      component: () => import("@/components/FeedbackInfo.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/survey',
      name: 'Polls',
      component: () => import("@/pages/Feedback.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/survey/:pollGroupId',
      name: 'ViewPolls',
      component: () => import("@/components/PollDetails.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/website',
      name: 'Website',
      component: () => import("@/pages/Website.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/website/settings',
      name: 'WebsiteSettings',
      component: () => import("@/pages/Website.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/payment',
      name: 'Payment',
      component: () => import("@/pages/Payment.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' },
      beforeEnter(to, from, next) {
        if(router.app.$session.get('role') === 2 ||
           router.app.$session.get('role') === 3){
          next({
            path:'/dasboard'
          })
        }else{
          next()
        }
      }
    },
    {
      path: '/team',
      name: 'Team',
      component: () => import("@/pages/Team.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' },
      beforeEnter(to, from, next) {
        if(router.app.$session.get('role') === 2 ||
           router.app.$session.get('role') === 3){
          next({
            path:'/dasboard'
          })
        }else{
          next()
        }
      }
    },
    {
      path: '/Company',
      name: 'Setting-Company',
      component: () => import("@/pages/Company.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' },
      beforeEnter(to, from, next) {
        if(router.app.$session.get('role') === 2 ||
           router.app.$session.get('role') === 3){
          next({
            path:'/dasboard'
          })
        }else{
          next()
        }
      }
    },

    {
      path: '/jointeam/:token',
      name: 'JoinTeam',
      component: () => import("@/pages/JoinTeam.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/timeline',
      name: 'Timeline',
      component: () => import("@/pages/Timeline.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import("@/pages/Contact.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/billing',
      name: 'Billing',
      component: () => import("@/pages/Billing.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/chat',
      name: 'ChatGPT',
      component: () => import("@/pages/ChatBot.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },      
    {
      path: '/device',
      name: 'Device',
      component: () => import("@/pages/Device.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'application' }
    },
    {
      path: '/recordings',
      name: 'Recordings',
      component: () => import("@/pages/Record.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/error-log',
      name: 'Error Log',
      component: () => import("@/pages/ErrorLog.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/heatmap',
      name: 'Heatmap',
      component: () => import("@/pages/Heatmap.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/heatmap/continuous',
      name: 'HeatmapContinuous',
      component: () => import("@/components/HeatmapContinuous.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/heatmap/split',
      name: 'HeatmapSplit',
      component: () => import("@/components/HeatmapSplit.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },    
    {
      path: '/share/heatmap-page/:encryptedParam',
      name: 'ShareHeatmap2',
      component: () => import("@/components/HeatmapContinuous.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/heatmap/ai',
      name: 'HeatmapAIPage',
      component: () => import("@/components/HeatmapAI.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },       
    {
      path: '/heatmap/:heatmap_profile_id',
      name: 'HeatmapView2',
      component: () => import("@/components/HeatmapContent.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/heatmap-v2/:heatmap_profile_id',
      name: 'HeatmapView2',
      component: () => import("@/components/HeatmapContent3.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/heatmap/view',
      name: 'HeatmapView',
      component: () => import("@/components/HeatmapContent.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/record/:findSession',
      name: 'Record2',
      component: () => import("@/pages/Record.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/profile/:visitor_id',
      name: 'Visitors',
      component: () => import("@/components/Profile.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/profile',
      name: 'Setting-Profile',
      component: () => import("@/pages/Profile.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/notification',
      name: 'Notification',
      component: () => import("@/pages/NotificationSetting.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/block-ip',
      name: 'BlockIp',
      component: () => import("@/pages/BlockIp.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/upgrade-account',
      name: 'ForcedCheckout',
      component: () => import("@/pages/Checkout.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/subscription',
      name: 'Upgrade',
      component: () => import("@/pages/Upgrade.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' },
      beforeEnter(to, from, next) {
        if(router.app.$session.get('role') === 2 ||
           router.app.$session.get('role') === 3){
          next({
            path:'/dasboard'
          })
        }else{
          next()
        }
      }
    },
    {
      path: '/redeem-code',
      name: 'CouponRedeem',
      component: () => import("@/pages/CouponRedeem.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    }, 
    {
      path: '/extend-trials',
      name: 'ExtentTrials',
      component: () => import("@/pages/ExtentTrial.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: () => import("@/pages/Checkout.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/newcheckout',
      name: 'Checkout-WL',
      component: () => import("@/pages/CheckoutWL.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/optimizecheckout',
      name: 'Checkout-Optimize',
      component: () => import("@/pages/OptimizeCheckout.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/developer',
      name: 'Setting-DevApi',
      component: () => import("@/pages/DevApi.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/qr-code',
      name: 'Qrcode',
      component: () => import("@/pages/Qrcode.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'application' }
    },
    {
      path: '/report',
      name: 'Reports',
      component: () => import("@/pages/Reports.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'report' }
    },
    {
      path: '/application',
      name: 'Application',
      component: () => import("@/pages/Application.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'application' }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import("@/pages/Settings.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'setting' }
    },
    {
      path: '/report/performance',
      name: 'Report-Performance',
      component: () => import("@/components/Reports/Performance.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'report' }
    },
    {
      path: '/report/hourly-traffic',
      name: 'Report-hourlyTraffic',
      component: () => import("@/components/Reports/HourlyTraffic.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'report' }
    },
    {
      path: '/report/daily-traffic',
      name: 'Report-dailyTraffic',
      component: () => import("@/components/Reports/DailyTraffic.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'report' }
    },
    {
      path: '/report/engagement',
      name: 'Report-engagement',
      component: () => import("@/components/Reports/Engagement.vue"),
      meta: { requiresAuth: true, layout: 'auth-menu', menu: 'report' }
    },
    {
      path: '/404',
      name: 'error',
      component: () => import("@/pages/404.vue"),
      meta: { requiresAuth: false, layout: "no-sidebar" }
    },
    {
      path: '/share/dashboard/:encryptedParam',
      name: 'ShareDashboard',
      component: () => import("@/pages/Dashboard.vue"),
      meta: { requiresAuth: false, layout: "share-link" }
    },
    {
      path: '/share/analytics/:encryptedParam',
      name: 'ShareAnalytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: false, layout: "share-link" }
    },
    {
      path: '/share/feedback/:feedbackId/:encryptedParam',
      name: 'ShareViewFeedback',
      component: () => import("@/components/FeedbackDetail.vue"),
      meta: { requiresAuth: false, layout: "share-link" }
    },
    {
      path: '/share/events/:key/:value/:encryptedParam',
      name: 'ShareEventsDetail',
      component: () => import("@/components/EventDetail.vue"),
      meta: { requiresAuth: false, layout: "share-link" }
    },
    {
      path: '/share/abResult/:test_id/:encryptedParam',
      name: 'ShareA/B Result',
      component: () => import("@/components/AbTestResult.vue"),
      meta: { requiresAuth: false, layout: "share-link" }
    },
    {
      path: '/share/survey/:pollGroupId/:encryptedParam',
      name: 'ShareViewPolls',
      component: () => import("@/components/PollDetails.vue"),
      meta: { requiresAuth: false, layout: "share-link" }
    },
    {
      path: '/share/form/result/:id/:encryptedParam',
      name: 'ShareForm Result',
      component: () => import("@/components/FormResult.vue"),
      meta: { requiresAuth: false, layout: "share-link" }
    },
    {
      path: '/share/funnel/:id/:id_name/:encryptedParam',
      name: 'ShareFunnel Flow',
      component: () => import("@/components/FunnelDetail.vue"),
      meta: { requiresAuth: false, layout: "share-link" }
    },
    {
      path: '/share/visitor/retention/:encryptedParam',
      name: 'ShareVisitorRetention',
      component: () => import("@/pages/VisitorRetention.vue"),
      meta: { requiresAuth: false, layout: "share-link" }
    },
    {
      path: '/share/visitor/acquisition/:encryptedParam',
      name: 'ShareAcqChannel',
      component: () => import("@/pages/VisitorAcquisition.vue"),
      meta: { requiresAuth: false, layout: "share-link" }
    },
    {
      path: '/share/visitor/map/:encryptedParam',
      name: 'ShareVisitorMaps',
      component: () => import("@/pages/VisitorMap.vue"),
      meta: { requiresAuth: false, layout: 'share-link' }
    },{
      path: '/share/analytics/:key1/:value1/:encryptedParam',
      name: 'ShareAnalytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: false, layout: 'share-link' }
    },
    {
      path: '/share/analytics/:key1/:value1/:key2/:value2/:encryptedParam',
      name: 'ShareAnalytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: false, layout: 'share-link' }
    },
    {
      path: '/share/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:encryptedParam',
      name: 'ShareAnalytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: false, layout: 'share-link' }
    },
    {
      path: '/share/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:key4/:value4/:encryptedParam',
      name: 'ShareAnalytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: false, layout: 'share-link' }
    },
    {
      path: '/share/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:key4/:value4/:key5/:value5/:encryptedParam',
      name: 'ShareAnalytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: false, layout: 'share-link' }
    },
    {
      path: '/share/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:key4/:value4/:key5/:value5/:key6/:value6/:encryptedParam',
      name: 'ShareAnalytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: false, layout: 'share-link' }
    },
    {
      path: '/share/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:key4/:value4/:key5/:value5/:key6/:value6/:key7/:value7/:encryptedParam',
      name: 'ShareAnalytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: false, layout: 'share-link' }
    },
    {
      path: '/share/analytics/:key1/:value1/:key2/:value2/:key3/:value3/:key4/:value4/:key5/:value5/:key6/:value6/:key7/:value7/:key8/:value8/:encryptedParam',
      name: 'ShareAnalytics',
      component: () => import("@/pages/Analytics.vue"),
      meta: { requiresAuth: false, layout: 'share-link' }
    },
    {
      path: '/heatmap-ai',
      name: 'HeatmapAI',
      component: () => import("@/components/HeatmapAI.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    }, 
    {
      path: '/recommendation/dashboard',
      name: 'Recommendation-Dashboard',
      component: () => import("@/pages/RecommendationDashboard.vue"),      beforeEnter: (to, from, next) => {
        if (router.app.$session.get('company_id') === 1) {
          next()
        } else {
          next('/')
        }
      },
      meta: { requiresAuth: true, layout: 'no-sidebar' }
    },
    {
      path: '/service-portal',
      name: 'servicePortal',
      component: () => import("@/pages/servicePortal.vue"),
      beforeEnter: (to, from, next) => {
        if (router.app.$session.get('company_id') === 1 || router.app.$session.get('paid_plan') === 104) {
          next()
        } else {
          next('/')
        }
      },
      meta: { requiresAuth: true, layout: 'no-sidebar' }
    }, 
    {       
      path: '/recommendations',
      name: 'Recommendations',
      component: () => import("@/pages/Recommendations.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/welcome',
      name: 'Mida Welcome Page',
      component: () => import("@/pages/Welcome.vue"),
      meta: { requiresAuth: true, layout: 'no-sidebar' }
    },
    {
      path: '/get-started/:widget_id?',
      name: 'Optimize Overview',
      component: () => import("@/pages/OptimizeOverview.vue"),
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/overview',
      name: 'Overview',
      component: () => import("@/pages/Overview.vue"),
      beforeEnter: (to, from, next) => {
        window.SELECTED_PLAN = router.app.$session.get('paid_plan')
        let planArray = [0, 4, 101, 102, 103, 105, 201, 202, 203]

        if (router.app.$isOptimize) {
          next('/get-started')
        } else if (planArray.includes(router.app.$session.get('paid_plan')) && !router.app.$isWhitelabel()) {
          next()
        } else {
          next('/dashboard')
        }
      },
      meta: { requiresAuth: true, layout: 'auth' }
    },
    { path: '*', redirect: '/' }
  ],
  mode: 'history'
})

router.beforeEach(async (to, from, next) => {
  // Cancel previous requests if there are any
  if (Vue.prototype.axiosCancelSource && !window.location.href.includes('optimize.howuku.com')) {
    Vue.prototype.axiosCancelSource.cancel();
  }

  if(to.path.includes('/share/') && !to.path.includes('/share/playback/')){
    let result = await router.app.$http.get(process.env.API_ENDPOINT + '/getshareLinkData/' + to.params.encryptedParam)
    let data = result.data[0]
    try {
      window.TEMP_JWT = JSON.parse(data.datas).jwt
      window.TEMP_WIDGET_ID = JSON.parse(data.datas).widget_id
      window.TEMP_START_DATE = JSON.parse(data.datas).startDate
      window.TEMP_END_DATE = JSON.parse(data.datas).endDate
      window.TEMP_COMPANY_ID = data.company_id
      window.TEMP_WIDGET_NAME = JSON.parse(data.datas).widget_name
    } catch(e) {}
  }

  let loggedin = router.app.$session.exists()
  // if (!loggedin) loggedin = router.app.$auth.isAuthenticated

  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (to.fullPath.substr(0,2) === "/#") {
    const path = to.fullPath.substr(2);
    next(path);
    return;
  }

  //allowedpage before lock user
  //let allowedPage = ['/profile', '/company', '/payment', '/block-ip', '/team', '/website', '/checkout', '/affiliate-program', '/subscription', '/upgrade-account', '/logout']

  let allowedPage = ['/checkout', '/upgrade-account', '/logout', '/extend-trials', '/newcheckout', '/optimizecheckout']
  let allowedPage2 = ['/checkout', '/upgrade-account', '/subscription', '/payment', '/logout', '/dashboard', '/extend-trials', '/card/add', '/newcheckout', '/optimizecheckout']

  // identify current user
  setTimeout(() => {
    try {
      let notTestEnvironment =
        !window.location.href.includes('localhost') &&
        !window.location.href.includes('demo.howuku.com') &&
        !window.location.pathname === '/hwlogin'
      if (notTestEnvironment) {
        _cio
          .identify({
            id: router.app.$session.get('email'), // Use either id or email.
            name: router.app.$session.get('name'),
          })
          .then(() => {})

        window.howuku
          .identify({
            id: router.app.$session.get('user_id'),
            name: router.app.$session.get('name'),
            email: router.app.$session.get('email'),
            company_id: router.app.$session.get('company_id'),
            odd_number: Number(router.app.$session.get('company_id')) % 2,
            paid_plan: router.app.$session.get('paid_plan'),
            lifetime: router.app.$session.get('lifetimedeal') ? 'Y' : 'N'
          })
          .then(() => {})
      }
    } catch (e) {}
  }, 2000)

  // if (loggedin && router.app.$session.get('paid_plan') === 0 && !allowedPage.includes(to.fullPath)) {
  //   window.location.href = '/upgrade-account'
  // } else

  // Create a new CancelToken source for the next requests
  Vue.prototype.axiosCancelSource = axios.CancelToken.source();

  if(router.app.$session.get('paid_plan_expiry_retry') !== null && loggedin && router.app.$session.get('paid_plan_expiry_retry') !== undefined){
    if(!allowedPage2.includes(to.path)){
      if (router.app.$session.get('whitelabel_ref_id')) {
        window.location.href = '/newcheckout';
      } else {
        window.location.href = '/subscription';
      }
      // window.location.href = '/subscription';
    }else if(to.path.match('/dashboard') && allowedPage2.includes(from.path) && !from.path.match('/dashboard')){
      window.location.href = '/dashboard';
    }else{
      next()
    }
  }else {
    next()
  }
  
  if (loggedin && router.app.$session.get('paid_plan') === 0 && !allowedPage.includes(to.path)) {
    if (router.app.$session.get('whitelabel_ref_id')) {
      window.location.href = '/newcheckout';
    } else if (window.location.href.includes('optimize.howuku.com')) {
      window.location.href = '/optimizecheckout'
    } else {
      window.location.href = '/upgrade-account';
    }
    // window.location.href = '/upgrade-account';  
  } else if (requiresAuth && !loggedin) {
      if (to.path && to.path !== '/') {
      window.location.href = '/login?redirect=' + to.fullPath
      }
      else window.location.href = '/login'
  } else {
    if (router.app.$session.get('widget_id')) router.app.$checkInstallationStatus()

    next()
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js